import { render, staticRenderFns } from "./forgotpwd.vue?vue&type=template&id=7573ef0d&scoped=true"
import script from "./forgotpwd.vue?vue&type=script&lang=js"
export * from "./forgotpwd.vue?vue&type=script&lang=js"
import style0 from "./forgotpwd.vue?vue&type=style&index=0&id=7573ef0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7573ef0d",
  null
  
)

export default component.exports